export default "__VITE_ASSET__DPt3xjRT__"